import { useLanguage } from '../../contexts/LanguageContext'

const EVALUATE_URL = 'https://www.trustpilot.com/evaluate/primedocumentsign.com'

export function TrustpilotReviewButton({ className = '' }) {
  const { t } = useLanguage()
  return (
    <a
      href={EVALUATE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`trustpilot-review-btn${className ? ` ${className}` : ''}`.trim()}
    >
      {t('trustpilot.leaveReview')}
    </a>
  )
}
